import { LOCALSTORAGE_AUTH2, LOCALSTORAGE_USERSSION } from "../common/constants";

// The embedded agenda calendar route lives in the path on deployed envs
// (history-mode router via the History-Mode meta tag) and in the hash on local dev
export const isAgendaWebviewLocation = (): boolean =>
    location.pathname.indexOf("/agenda-webview") >= 0
    || location.hash.indexOf("/agenda-webview") >= 0;

export const BOOTSTRAP_CACHE_KEYS = {
    AUTH_CONFIG: "authConfig",
    USER_RIGHTS: "userRights"
};

const CACHE_PREFIX = "webviewBootstrapCache";

// Same-origin frames share localStorage but NOT Vuex memory: the WebApp's
// bootstrap responses are persisted here so the embedded agenda calendar can
// hydrate without refetching them on every iframe load. Entries are validated
// against the logged-in identity so a user/customer switch invalidates them.
const cacheIdentity = (): string => {
    try {
        const authInfo = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH2) || "{}");
        const userInfo = JSON.parse(localStorage.getItem(LOCALSTORAGE_USERSSION) || "{}");
        const customer = authInfo?.data?.information?.customerName || "";
        const email = userInfo?.UserInfo?.Email || "";
        return customer && email ? `${customer}/${email}` : null;
    } catch (error) {
        return null;
    }
};

export const saveBootstrapCache = (key: string, data: any): void => {
    try {
        const identity = cacheIdentity();
        if (!identity || data == null) return;
        localStorage.setItem(`${CACHE_PREFIX}.${key}`, JSON.stringify({ identity, data }));
    } catch (error) {
        // Best-effort cache: quota or serialization failures just skip caching
    }
};

export const loadBootstrapCache = (key: string): any => {
    try {
        const raw = localStorage.getItem(`${CACHE_PREFIX}.${key}`);
        if (!raw) return null;
        const entry = JSON.parse(raw);
        const identity = cacheIdentity();
        if (!identity || !entry || entry.identity !== identity) return null;
        return entry.data;
    } catch (error) {
        return null;
    }
};
